import React from "react";
import connect from "../i18n/connect";
import { updateStocksListSource } from "../redux/modules/tags";

export default function withStocksListSourceSetter(WrappedComponent) {
  const mapDispatchToProps = {
    updateStocksListSource
  };

  @connect(null, mapDispatchToProps)
  class WithStocksListSourceSetter extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithStocksListSourceSetter;
}
